import React, { useContext } from 'react';
import { ServerContext } from '@bingads-webui-campaign-react/server-context';
import { CampaignFetchProvider } from '@bingads-webui-campaign-react/campaign-http';

/**
 * Provides a fetch context pointed at the public Microsoft Advertising API
 * (Campaign Management endpoint). Wrap any component or hook that calls
 * Campaign Management routes (e.g. Brand Kit) so requests resolve against
 * `serverContext.ServicesEndpoints.CmAPI` rather than whatever fetch
 * context the host app installed.
 *
 * @param {object} props - children to render
 * @returns {JSX.Element} rendered tree
 */
export const CampaignManagementFetchProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const serverContext: any = useContext(ServerContext);
  const cmApiUrl: string | undefined = serverContext?.ServicesEndpoints?.CmAPI;

  return (
    <CampaignFetchProvider url={cmApiUrl}>
      {children}
    </CampaignFetchProvider>
  );
};
